import React from "react"
import { Heading, Text } from "@atoms"
import { theme } from "@theme"
import { wordTime } from "@utils/wordTime"
import cardPlaceholderImg from "./card-placeholder.jpg"
import { CardContainer, ImageWrapper } from "./styles/NewsMediaCard.styled"
import OptimizedImage from "../../utils/optimizedImage"
import { ConditionalWrapper } from "../../atoms/ConditionalWrapper"

function truncate(input) {
  if (input.length > 130) {
    return input.substring(0, 130) + "..."
  }
  return input
}

function truncateSixty(input) {
  if (input.length > 60) {
    return input.substring(0, 60) + "..."
  }
  return input
}

export const NewsMediaCard = ({
  title,
  description,
  link,
  featuredImg,
  gatsbyImage,
  border,
  blogBody,
}) => {
  return (
    <ConditionalWrapper
      condition={link}
      wrapper={children => (
        <a href={link} target="_blank" rel="noopener noreferrer"  style={{ display: "block", padding: "0px", textDecoration: "none" }}>
          {children}
        </a>
      )}
    >
      <CardContainer
        data-comp={NewsMediaCard.displayName}
        theme={theme}
        border={border}
      >
        <ImageWrapper>
          <OptimizedImage
            alt='media logo'
            image={gatsbyImage}
            src={featuredImg || cardPlaceholderImg}
          />
        </ImageWrapper>
        {title && (
          <Heading
            headingSize="H6"
            style={{
              paddingBottom: "8px",
            }}
          >
            {truncateSixty(title)}
          </Heading>
        )}
        {description && <Text>{truncate(description)}</Text>}
        <div
          style={{
            marginTop: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "baseline",
          }}
        >
          <p className="card--read-more">Learn More</p>
          {blogBody && (
            <p className="card--read-time">{wordTime(blogBody?.raw)}</p>
          )}
        </div>
      </CardContainer>
    </ConditionalWrapper>
  )
}

NewsMediaCard.displayName = "NewsMediaCard"
